/* =========================================================================
   Grivet Shoe Quiz — GA4 + Meta Pixel + TikTok parallel analytics
   All functions defensive: they no-op cleanly when a tag isn't installed,
   so the quiz keeps working even if a tracker isn't wired yet.
   ========================================================================= */
(function () {
  'use strict';

  function ga(event, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', event, params || {});
    } catch {}
  }
  function fb(event, params) {
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', event, params || {});
    } catch {}
  }
  function tt(event, params) {
    try {
      if (typeof window.ttq === 'object' && window.ttq.track) window.ttq.track(event, params || {});
    } catch {}
  }

  function fireAll(event, params) { ga(event, params); fb(event, params); tt(event, params); }

  var QA = {
    started: function (ctx) {
      fireAll('quiz_started', {
        quiz_version: ctx.version, detected_region: ctx.tier,
        detected_state: ctx.detected && ctx.detected.region
      });
    },
    answered: function (qid, answer, timeMs) {
      ga('quiz_question_answered', { question_id: qid, answer_id: String(answer).slice(0, 100), time_on_question_ms: timeMs });
    },
    completed: function (ctx, top3, profileName) {
      fireAll('quiz_completed', {
        fit_profile: profileName,
        primary_activity: ctx.answers.q1,
        weekly_volume: ctx.answers.q6,
        top_match_sku: top3 && top3[0] && top3[0].shoe.variants[0] && top3[0].shoe.variants[0].sku
      });
    },
    emailCaptured: function (email, smsOptIn) {
      fireAll('generate_lead', {
        currency: 'USD', value: 0,
        lead_type: smsOptIn ? 'email+sms' : 'email'
      });
      fireAll('quiz_email_captured', { sms_opted_in: !!smsOptIn });
    },
    emailSkipped: function (profileName) {
      ga('quiz_email_skipped', { fit_profile: profileName });
    },
    viewedResults: function (top3) {
      fireAll('view_item_list', {
        item_list_name: 'Shoe Quiz Results',
        items: (top3 || []).map(function (s, i) {
          return {
            item_id: String(s.shoe.id),
            item_name: s.shoe.title,
            item_brand: s.shoe.brand,
            index: i + 1,
            price: s.shoe.price
          };
        })
      });
    },
    clickedRecommendation: function (shoe, position) {
      fireAll('select_item', {
        item_list_name: 'Shoe Quiz Results',
        items: [{ item_id: String(shoe.id), item_name: shoe.title, item_brand: shoe.brand, index: position, price: shoe.price }]
      });
    },
    addedShoeToCart: function (shoe, variant, pickup) {
      fireAll('add_to_cart', {
        currency: 'USD', value: shoe.price,
        items: [{ item_id: variant && variant.sku, item_name: shoe.title, item_brand: shoe.brand, price: shoe.price, quantity: 1 }],
        fulfillment: pickup ? 'pickup' : 'ship'
      });
    },
    retook: function () { ga('quiz_retook', {}); }
  };

  window.GrivetQuizAnalytics = QA;
})();
